module.exports = __webpack_public_path__ + "static/media/Artboard10.d75705af.png";